import React, { useState } from 'react';
import { Form, Row, Stack, Button, FloatingLabel } from 'react-bootstrap';
import axios from 'axios';
import { config } from '../config/config';
import { Link, useLocation } from 'react-router-dom';

const AddMembership = () => {
  const membership = useLocation();
  const data = membership.state;

  const [membershipData, setMembershipData] = useState(
    data
      ? data
      : {
        plan: '',
        price: null,
        connectHours: null,
        validityDays: null,
        membershipType: '',
        description: '',
      }
  );

  const {
    plan,
    price,
    connectHours,
    validityDays,
    membershipType,
    description,
  } = membershipData;

  const onChange = (e) => {
    setMembershipData({ ...membershipData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      console.log(membershipData);
      const request = await axios.post(
        'https://provider.numente.io/membershipPlan/createMembershipPlan',
        membershipData,
        config
      );
      if (request.data.success === true) {
        alert('Membership created');
      } else {
        alert('Could not create membership');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='container'>

        <div className='shadow rounded p-4 my-5' style={{ background: "#F7FAFC" }}>
          <div className='my-4 '>
            {data === undefined || data === {} || data === null ? (
              <h2 className='f2-2 mb-0'>New Membership</h2>
            ) : (
              <h2 className='f2-2 mb-0'>Membership Details</h2>
            )}
          </div>
          <div className='my-3 fs-4 fw-medium text-secondary'>Membership Details</div>
          <Form onSubmit={handleSubmit}>
            <Row className='row'>
              <div className='col-12 col-md-5 my-2'>
                <Form.Label className='form-label m-0'>Plan Name</Form.Label>
                <input
                  name='plan'
                  value={plan}
                  type='text'
                  className='form-control'
                  placeholder='Gold'
                  onChange={onChange}
                  disabled={data !== null}
                />
              </div>
              <div className='col-12 col-md-5 my-2'>
                <Form.Label className='form-label m-0'>Plan Price</Form.Label>
                <input
                  name='price'
                  value={price}
                  type='text'
                  className='form-control'
                  placeholder='200 USD'
                  onChange={onChange}
                  disabled={data !== null}
                />
              </div>
              <div className='col-12 col-md-5 my-2'>
                <Form.Label className='form-label m-0'>
                  Connect Hours
                </Form.Label>
                <input
                  name='connectHours'
                  value={connectHours}
                  type='text'
                  className='form-control'
                  placeholder='30'
                  onChange={onChange}
                  disabled={data !== null}
                />
              </div>
              <div className='col-12 col-md-5 my-2'>
                <Form.Label className='form-label m-0'>
                  Validity Days
                </Form.Label>
                <input
                  name='validityDays'
                  value={validityDays}
                  type='text'
                  className='form-control'
                  placeholder='30 days'
                  onChange={onChange}
                  disabled={data !== null}
                />
              </div>
              <div className='col-12 col-md-5 my-2'>
                <Form.Label className='form-label m-0'>Type</Form.Label>
                <input
                  type='text'
                  name='membershipType'
                  value={membershipType}
                  className='form-control'
                  aria-label='Family,B2C etc'
                  onChange={onChange}
                  disabled={data !== null}
                />
              </div>
              <div className='my-4'>
                <Form.Label className='form-label m-0'>Description</Form.Label>
              </div>
              <FloatingLabel>
                <Form.Control
                  name='description'
                  value={description}
                  as='textarea'
                  placeholder='Enter description here'
                  style={{ height: '100px' }}
                  onChange={onChange}
                  disabled={data !== null}
                />
              </FloatingLabel>
            </Row>
            <div className='d-flex justify-content-center align-content-center '>
              <div className='py-4 me-3'>
                <Button type='submit' variant='primary'>
                  Save
                </Button>
              </div>
              <div className='py-4'>
                <Link to='/membership'>
                  <Button variant='danger'>Cancel</Button>
                </Link>
              </div>
            </div>
            {/* <Row>
              <Stack direction='horizontal' gap={3}>
              </Stack>
            </Row> */}
          </Form>
        </div>
      </div>
    </>
  );
};

export default AddMembership;
